namespace TabAurous.Finance {
    export interface ExpenseRow {
        TransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        SuffixPrefixId?: number;
        TransDate?: string;
        RefNo?: string;
        RefDate?: string;
        EnteredBy?: string;
        LedgerId?: number;
        LedgerName?: string;
        TotalAmount?: number;
        Narration?: string;
        VoucherTypeId?: number;
        UserId?: number;
        FinancialYearId?: number;
        CurrencyId?: number;
        ExchangeRate?: number;
        CompanyId?: number;
        TaxAmount?: number;
        TaxLedgerId?: number;
        Details?: ExpenseDetailRow[];
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ExpenseRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.Expense';
        export const deletePermission = 'Finance:Expense:Delete';
        export const insertPermission = 'Finance:Expense:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:Expense:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            SuffixPrefixId = "SuffixPrefixId",
            TransDate = "TransDate",
            RefNo = "RefNo",
            RefDate = "RefDate",
            EnteredBy = "EnteredBy",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            TotalAmount = "TotalAmount",
            Narration = "Narration",
            VoucherTypeId = "VoucherTypeId",
            UserId = "UserId",
            FinancialYearId = "FinancialYearId",
            CurrencyId = "CurrencyId",
            ExchangeRate = "ExchangeRate",
            CompanyId = "CompanyId",
            TaxAmount = "TaxAmount",
            TaxLedgerId = "TaxLedgerId",
            Details = "Details",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
